import { FunctionComponent, useEffect, useState } from 'react';
import HowToUseRA, { ReturnMethod } from '../../../components/about-page/HowToUseRA';
import { getDomainFromFullUrl, getIframeParentUrl } from '../../../utils/url';
import {
    AboutPageConfigs,
    PartnerUserService,
    NewAboutPageConfigs,
} from '../../../services/partnerUser.service';
import { getPageHeight } from '../../../utils/layout';

const HowToPage: FunctionComponent = () => {
    const [info, setInfo] = useState<NewAboutPageConfigs>();

    useEffect(() => {
        (async () => {
            // const domain = getDomainFromFullUrl(getIframeParentUrl());
            // const Shopify = globalWindow?.parent?.Shopify;
            // const domain = Shopify?.shop;
            try {
                const globalWindow = window as any;
                const domain = globalWindow.location.search.split('?admin_domain=')[1];
                const config = await PartnerUserService.getNewAboutPageConfigs(domain);
                setInfo(config);
            } catch (err) {
                // todo Wait for the API implementation
                // window.location.href = '/404';

                setInfo({
                    returnToSeel: true,
                    shopDomain: '_',
                    returnWindow: '_',
                });
            }

            window.setTimeout(() => {
                window.parent.postMessage(
                    JSON.stringify({
                        token: 'ra-message:set-height',
                        height: getPageHeight(),
                    }),
                    '*'
                );
            }, 1000);
        })();
    }, []);

    return info ? <HowToUseRA {...info} /> : null;
};

export default HowToPage;
